import React from 'react'
import PropTypes from 'prop-types'

const ZTLogotypeSvg = ({ color, ...rest }) => (
  <svg
    xmlns="http://www.w4.org/2000/svg"
    viewBox="0 0 119 150"
    fill={color}
    {...rest}
  >
    <g>
      <path d="M118.9,150.38H13.55l-13.74-25V103.66L45.07,51H15.67L1.92,26V0H105.2l13.7,25V46.87l-.44.5-44.76,52h31.5l13.7,25Zm-103.22-3.6H115.3v-21.5L103.07,103H65.86L115.3,45.53V25.92L103.07,3.59H5.51V25.1L17.79,47.42h35.1L3.41,105v19.42Z" />
      <polygon points="15.67 27.4 2.14 2.66 5.29 0.93 17.79 23.81 117.1 23.66 117.1 27.25 15.67 27.4" />
      <polygon points="16.41 148.58 12.82 148.58 12.82 125.34 0.09 105.28 3.13 103.36 16.41 124.3 16.41 148.58" />
      <rect x="14.93" y="25.61" width="3.59" height="23.61" />
      <polygon points="69.78 102.95 32.44 102.95 78.22 51.15 48.97 51.01 48.99 47.42 86.16 47.59 40.41 99.36 69.78 99.36 69.78 102.95" />
      <rect x="14.62" y="123.02" width="102.48" height="3.59" />
    </g>
  </svg>

)

ZTLogotypeSvg.propTypes = {
  color: PropTypes.string
}

export default ZTLogotypeSvg
